export const GET_USER = 'GET_USER';
export const CREATE_STORE = 'CREATE_STORE';
export const GET_STORE = 'GET_STORE';
export const USER_LOADING = 'USER_LOADING';
